import React from 'react';
import PropTypes from 'prop-types';

export default function ServiceModal({ service, onClose }) {
  const Icon = service.Icon;
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        <div className="card-icon"><Icon /></div>
        <h3>{service.name || service.title || service.Icon?.displayName}</h3>
        <p style={{ fontSize: '1.125rem', lineHeight: '1.8', color: 'var(--text-dark)', marginTop: '1rem' }}>{service.description}</p>

        <div style={{ marginTop: '2rem' }}>
          <h4 style={{ marginBottom: '1rem' }}>Key Benefits</h4>
          <ul style={{ listStyle: 'disc', paddingLeft: '1.5rem', color: 'var(--text-dark)', lineHeight: '1.8' }}>
            <li>Expert team with proven track record</li>
            <li>Customized approach for your needs</li>
            <li>Ongoing support and maintenance</li>
            <li>Competitive pricing and timely delivery</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

ServiceModal.propTypes = {
  service: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired
};
